/* 全局方法 */
import _ from 'lodash'
import { bucketCdnHost, bucketHost } from '~/utils/common'



export default defineNuxtPlugin({
  name: 'v-counter',
  setup(nuxtApp) {
  // 注册全局方法
  nuxtApp.vueApp.config.globalProperties.$get = _.get

  // 注册全局过滤器
  nuxtApp.vueApp.config.globalProperties.$filters = {
    cover(value: string) {
      let parse: any = value
      if (typeof value === 'string') {
        try {
          parse = JSON.parse(value)[0]
            .replace('http://', 'https://')
            .replace(bucketHost, bucketCdnHost)
        } catch (error) {
          parse = value
          console.error(error)
        }
      }
      return parse
    },
    numFormat(str: string) {
      const num = parseInt(str)
      if (num >= 10000) {
        return `${(num / 10000).toFixed(1)}w`
      }
      return num
    }
  }

  // 注册全局指令
  nuxtApp.vueApp.directive('webpBg', {
    mounted(el: any) {
      if (el) {
        const str = el.getAttribute('class')?.split(' ')
        str.push('webpa')
        el.setAttribute('class', str.join(' '))
      }
    }
  })

    // PDF 导出方法已优化为按需加载模式，详见 v-counter.client.ts 和 usePDFExport composable
  }
})
